import React from "react";
import "./DiscardNewNote.css";

function DiscardNewNote(props: {callback: () => void}): JSX.Element {
    return (
        <div className="discardNewNote" onClick={props.callback}>
            <p className="discardNewNoteText">Discard</p>
        </div>
    )
}

export default DiscardNewNote;